const t = {
  labelTextColor: "var(--gray-700)",
  feedbackTextColor: "var(--gray-600)",
  blankHeight: "var(--line-height-2xl)",
  feedbackTextColorError: "var(--error-500)",
  labelFontWeight: "var(--font-weight-medium)"
}, l = (e) => ({
  labelFontSize: "var(--font-size-xs)",
  labelLineHeight: "var(--line-height-xs)",
  feedbackFontSize: "var(--font-size-2xs)",
  feedbackLineHeight: `calc( var(--line-height-2xs) * ${e} )`,
  blankHeight: "var(--line-height-xs)",
  labelHeight: "var(--line-height-xs)"
}), a = (e) => ({
  labelFontSize: "var(--font-size-sm)",
  labelLineHeight: "var(--line-height-sm)",
  feedbackFontSize: "var(--font-size-xs)",
  feedbackLineHeight: `calc( var(--line-height-xs) * ${e} )`,
  blankHeight: "var(--line-height-sm)",
  labelHeight: "var(--line-height-sm)"
}), n = (e) => ({
  labelFontSize: "var(--font-size-md)",
  labelLineHeight: "var(--line-height-md)",
  feedbackFontSize: "var(--font-size-sm)",
  feedbackLineHeight: `calc( var(--line-height-sm) * ${e} )`,
  blankHeight: "var(--line-height-md)",
  labelHeight: "var(--line-height-md)"
}), h = (e) => ({
  labelFontSize: "var(--font-size-lg)",
  labelLineHeight: "var(--line-height-lg)",
  feedbackFontSize: "var(--font-size-md)",
  feedbackLineHeight: `calc( var(--line-height-md) * ${e} )`,
  blankHeight: "var(--line-height-lg)",
  labelHeight: "var(--line-height-lg)"
}), g = (e) => ({
  labelFontSize: "var(--font-size-2xl)",
  labelLineHeight: "var(--line-height-2xl)",
  feedbackFontSize: "var(--font-size-lg)",
  feedbackLineHeight: `calc( var(--line-height-lg) * ${e} )`,
  blankHeight: "var(--line-height-2xl)",
  labelHeight: "var(--line-height-2xl)"
}), r = (e) => ({
  labelFontSize: "var(--font-size-2xl)",
  labelLineHeight: "var(--line-height-2xl)",
  feedbackFontSize: "var(--font-size-lg)",
  feedbackLineHeight: `calc( var(--line-height-lg) * ${e} )`,
  blankHeight: "var(--line-height-2xl)",
  labelHeight: "var(--line-height-2xl)"
});
function s(e = "2xs", i = 1) {
  return {
    ...t,
    ...{
      lg: r,
      md: g,
      sm: h,
      xs: n,
      "2xs": a,
      "3xs": l
    }[e](i)
  };
}
export {
  s as createFormInputSizes
};
//# sourceMappingURL=highrise.es351.js.map
